import Vue from 'vue'

export function shortFio(fio) {
  if (!fio) return ''

  let result = ''

  fio.split(/\s+/).forEach((split, index) => {
    if (index === 0) {
      result = split
    } else {
      // Если слово уже сокращено (заканчивается на точку), оставляем как есть
      const shortPart = split.endsWith('.') ? split : `${split[0].toUpperCase()}.`
      result = `${result} ${shortPart}`
    }
  })

  return result
}

Vue.filter('shortFio', (fio) => {
  if (Array.isArray(fio)) return fio.map(shortFio).join(', ')
  else return shortFio(fio)
})
